<template>
  <v-container fluid>
    <v-row class="device_details" :class="!$route.params.deviceId ? '' : 'pl-3 pr-3'">
      <v-col cols="12" class="pa-0">
        <v-toolbar class="add-opacity" color="backgroundLight" :flat="true">
          <v-toolbar-title v-if="!$route.params.deviceId" class="title primaryGrey--text">
            <router-link :to="`/scavenger_health/${deviceId}`">
              <v-icon class="mr-3" small color="primaryGrey">mdi-open-in-new</v-icon
              >{{ $t("common.labels.openAsPage") }}
            </router-link>
          </v-toolbar-title>
          <v-toolbar-title v-if="$route.params.deviceId" class="title primaryGrey--text">
            <router-link :to="`/scavenger_health`">
              <v-icon class="mr-3" color="primaryGrey">mdi-keyboard-backspace</v-icon>{{ $t("common.words.back") }}
            </router-link>
          </v-toolbar-title>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row v-if="device_data" class="common-card-row">
      <v-col cols="12" md="6">
        <v-row class="pa-0 pr-md-3 pb-3 pb-md-0">
          <v-col cols="12" class="common-card-col mb-3">
            <div class="font-weight-bold titleLight--text">
              {{ device_data.AssetName }} -
              {{ deviceId || $route.params.deviceId }}

              <v-icon
                v-if="$route.params.deviceId"
                color="primary"
                class="pl-2 pb-1 pointer"
                title="Edit Device Details"
                @click="
                  dialog = true;
                  overlay_type = 'edit';
                "
                small
                >mdi-pencil</v-icon
              >
              <router-link class="no-style" target="_blank" to="/scavenger_alerts">
                <v-icon color="vtred" class="pl-2 pb-1 pointer" title="Manage alerts" small>mdi-bell-plus</v-icon>
              </router-link>
            </div>
            <div v-if="device_data.CurrentLat" class="d-flex mt-1 text-caption primaryGrey--text">
              <div><v-icon class="mr-1" color="primary" small>mdi-latitude</v-icon>{{ device_data.CurrentLat }}</div>
              <div class="ml-3">
                <v-icon class="mr-1" color="primary" small>mdi-longitude</v-icon>{{ device_data.CurrentLng }}
              </div>
            </div>
            <v-row class="mt-3" v-if="device_data">
              <v-col
                cols="6"
                class="font-weight-bold titleLight--text"
                v-for="(data, index) in page_content.device_details_health"
                :key="index"
              >
                <div class="text-caption">
                  {{ data.label }}
                </div>
                <span v-for="(item, index) in device_data[data.value]" :key="index">
                  <TooltipVT
                    :icon="getValueFromConfig(item, data.value, 'icon')"
                    :color="getValueFromConfig(item, data.value, 'color')"
                    :text="item"
                  />
                  {{ " " }}
                  <span v-if="item == 'Temperature'">85°C</span>
                </span>
                <span v-if="data.suffix && device_data[data.value]">{{ data.suffix }}</span>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="common-card-col">
            <v-row>
              <v-col>
                <div class="font-weight-bold titleLight--text">
                  Values
                  <TooltipVT :icon="'mdi-information-outline'" :text="values_tooltip" />
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="pl-4" v-for="(data, index) in page_content.health_statictics" :key="index">
                <v-row no-gutters>
                  <v-col>
                    <div class="width-50 text-caption titleLight--text">
                      <v-icon small v-if="data.icon">{{ data.icon }}</v-icon>
                      {{ data.label }}
                    </div>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col>
                    <div class="pr-4 text-h6">
                      <span v-for="(coldata, idx) in data.values" :key="idx"
                        ><span v-if="data.type == 'datetime'">{{ device_data[coldata] | date }}</span>
                        <span v-if="data.type == 'date'">{{ $dateFormat(device_data[coldata]) }}</span>
                        <span
                          v-if="
                            data.type == 'lookup' &&
                            (!(coldata in device_data) || (device_data[coldata] && device_data['Status'] != 3))
                          "
                          :class="`${data.colors[idx]}--text`"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">Unknown</span>
                            </template>
                            <span
                              ><b>Status:</b> {{ page_content.Status[device_data["Status"]] }}<br /><b>Operation:</b
                              >{{ page_content.Operation[device_data["Operation"]] }}</span
                            >
                          </v-tooltip>
                        </span>
                        <span v-else :class="`${data.colors[idx]}--text`">
                          {{ device_data[coldata] | round }}
                        </span>
                        <span class="text-caption" v-if="data.suffix && device_data[coldata]">{{ data.suffix }}</span
                        ><span v-if="idx != data.values.length - 1"> /</span></span
                      ><span v-if="data.type == 'datetime'">{{ device_data[data.value] | date }}</span>
                      <span v-if="data.type == 'date'">{{ $dateFormat(device_data[data.value]) }}</span>
                      <span v-else class="vtblue--text">
                        {{ device_statistics[data.value] }}
                      </span>
                      <span class="text-caption font-weight-light" v-if="data.helptext">{{ data.helptext }}</span>
                      <span class="text-caption" v-if="data.suffix && device_data[data.value]">{{ data.suffix }}</span>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="6" class="pa-0">
        <v-col cols="12" class="common-card-col">
          <MapsVT
            height="40vh"
            :options="page_content.maps_config"
            :items="map_data"
            :center="get_center"
            :showRoute="!show_info_window"
            :hide_legends="show_info_window"
          />
        </v-col>
      </v-col>
    </v-row>
    <v-row class="common-card-row pb-3">
      <v-col class="common-card-col">
        <v-row>
          <PrimaryFiltersVT
            :list_filters="tabs"
            @filter_update="update_current_tab($event)"
            :current_tab="current_tab"
          />
        </v-row>
        <v-row no-gutter class="mt-3">
          <v-col cols="12" v-if="!charts_data || !message_list">
            <v-skeleton-loader type="image"></v-skeleton-loader>
          </v-col>
          <v-col cols="12" v-else>
            <v-row no-gutters class="primaryDark--text" v-if="current_tab == 'Charts'">
              <v-col cols="12">
                <v-row no-gutters v-for="(data, index) in page_content.scavenger_health_charts" :key="index">
                  <v-col cols="12">
                    <div class="primaryOutline--text text-subtitle-2 px-4">
                      {{ data.label }}
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <LineChart
                      :from_min="from_min"
                      :chartData="data"
                      :no_zooming="no_zooming"
                      :data="charts_data[index]"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters class="primaryDark--text" v-if="current_tab == 'Messages'">
              <v-col cols="12">
                <DataTableVT
                  :headers="page_content.scavenger_health_table"
                  sort_by="Timestamp"
                  :items_list="message_list"
                  :no_search="no_search"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MapsVT from "../components/MapsVT";
import TooltipVT from "../components/TooltipVT";
import LineChart from "../components/LineChart";
import DataTableVT from "../components/DataTableVT";
import PrimaryFiltersVT from "../components/PrimaryFiltersVT";
import { content } from "../../config/scavenger.js";

export default {
  name: "ScavengerHealthDetails",
  props: { deviceId: String, asset_detail_data: Object },
  components: {
    MapsVT,
    TooltipVT,
    DataTableVT,
    PrimaryFiltersVT,
    LineChart,
  },
  data() {
    return {
      page_config: null,
      page_content: null,
      device_data: null,
      device_statistics: null,
      dialog: false,
      overlay_type: "",
      current_tab: "Charts",
      snackbar: false,
      from_min: true,
      show_info_window: true,
      message_list: null,
      no_search: true,
      flat: true,
      no_zooming: true,
      values_tooltip: "Captured maximum value of the device",
      tabs: [
        {
          value: "Charts",
          label: this.$t("views.ScavengerH2Details.tabs.charts.label"),
        },
        {
          value: "Messages",
          label: this.$t("views.ScavengerH2Details.tabs.messages.label"),
        },
      ],
    };
  },
  watch: {
    deviceId: function () {},
  },
  created() {
    this.page_config = this.$config;
  },
  mounted() {
    this.page_content = content;
    let id = this.deviceId || this.$route.params.deviceId;
    this.device_id = id;

    //this.get_device_details(id);
    //this.get_messages(id);

    this.device_data = {
      AssetID: "B24F21",
      AssetName: "Asset 1",
      Ageing: ["FutureAgeing"],
      Hydrogen: ["HydrogenAlert", "HydrogenRateOfChangeAlert"],
      RiskOfOverload: ["RiskOfOverload"],
      AssetReplacementMaintenance: ["Temperature"],
      IsWatchlisted: true,
      CurrentLat: "53.350140",
      CurrentLng: "-6.266155",
    };

    this.device_statistics = {
      Ageing: 50,
      Hydrogen: 7650,
      RiskOfOverload: 150,
      AssetReplacementMaintenance: 135,
    };

    this.message_list = [
      {
        seqNo: 454,
        DeviceID: "111110",
        Timestamp: "2022-06-30T21:55:00.000+00:00",
        H2Lvl: 6000,
        PCBTemp: 105,
        AccelerationAgeing: 223,
        RateOfChange: 65,
      },
      {
        seqNo: 455,
        DeviceID: "111110",
        Timestamp: "2022-06-30T22:45:00.000+00:00",
        H2Lvl: 5900,
        PCBTemp: 105,
        AccelerationAgeing: 364,
        RateOfChange: 43,
      },
      {
        seqNo: 456,
        DeviceID: "111110",
        Timestamp: "2022-06-30T23:50:00.000+00:00",
        H2Lvl: 6000,
        PCBTemp: 105,
        AccelerationAgeing: 54,
        RateOfChange: 10,
      },
      {
        seqNo: 457,
        DeviceID: "111111",
        Timestamp: "2022-07-01T08:15:00.000+00:00",
        H2Lvl: 5300,
        PCBTemp: 95,
        AccelerationAgeing: 290,
        RateOfChange: 27,
      },
      {
        seqNo: 458,
        DeviceID: "111111",
        Timestamp: "2022-07-01T10:30:00.000+00:00",
        H2Lvl: 5200,
        PCBTemp: 98,
        AccelerationAgeing: 123,
        RateOfChange: 8,
      },
      {
        seqNo: 459,
        DeviceID: "111112",
        Timestamp: "2022-07-01T15:50:00.000+00:00",
        H2Lvl: 6200,
        PCBTemp: 110,
        AccelerationAgeing: 432,
        RateOfChange: 55,
      },
      {
        seqNo: 460,
        DeviceID: "111112",
        Timestamp: "2022-07-01T17:20:00.000+00:00",
        H2Lvl: 6300,
        PCBTemp: 108,
        AccelerationAgeing: 76,
        RateOfChange: 14,
      },
    ];
  },
  methods: {
    get_device_details(id) {
      // API call to get device list
    },
    get_messages(id) {
      // API call to get message list
    },
    update_current_tab(val) {
      this.current_tab = val;
    },
    getValueFromConfig(value, key, type) {
      if (typeof value == "object" && value.length > 0) {
        value = value[0];
      }
      value = (value && typeof value == "string" && value.trim()) || value;
      let valueLower = (value && typeof value == "string" && value.trim().toLowerCase()) || value;

      return (
        (this.page_config[key] && this.page_config[key][type] && this.page_config[key][type][value]) ||
        (this.page_config[key] && this.page_config[key][type] && this.page_config[key][type][valueLower]) ||
        (type == "color" ? "primaryDark" : "")
      );
    },
  },
  computed: {
    charts_data() {
      return this.message_list
        ? [
            [
              {
                id: "ageing",
                label: "Ageing",
                suffix: "g",
                type: "line",
                values: this.message_list
                  .filter((e) => {
                    return !!e.AccelerationAgeing;
                  })
                  .map((e) => {
                    return {
                      key: new Date(e.Timestamp),
                      value: e.AccelerationAgeing,
                    };
                  }),
              },
            ],
            [
              {
                id: "h2",
                label: "H₂ Level",
                suffix: "ppm",
                type: "line",
                values: this.message_list
                  .filter((e) => {
                    return !!e.H2Lvl;
                  })
                  .map((e) => {
                    return { key: new Date(e.Timestamp), value: e.H2Lvl };
                  }),
              },
            ],
            [
              {
                id: "rate_change",
                label: "Rate of Change",
                suffix: "g",
                type: "line",
                values: this.message_list
                  .filter((e) => {
                    return !!e.RateOfChange;
                  })
                  .map((e) => {
                    return {
                      key: new Date(e.Timestamp),
                      value: e.RateOfChange,
                    };
                  }),
              },
            ],
          ]
        : null;
    },
    computed_location_details() {
      let temp_obj = JSON.parse(JSON.stringify(this.device_data));
      return temp_obj;
    },
    map_data: function () {
      return this.computed_location_details.CurrentLat ? [this.computed_location_details] : [];
    },
    get_center: function () {
      return this.map_data
        ? new window.google.maps.LatLng(
            this.computed_location_details.CurrentLat,
            this.computed_location_details.CurrentLng
          )
        : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.device_details {
  .title {
    font-size: 0.75rem !important;
    font-family: Trade Gothic Regular !important;
  }
}
.border-bottom {
  border-bottom: 1px solid var(--v-restingOutline-base);
}
.border-right {
  border-right: 1px solid var(--v-restingOutline-base);
}
.duration_select_div {
  .duration_select {
    width: 9em;
    margin-right: 1em;
  }
  .asset_select {
    width: 25em;
    .v-input {
      max-width: 80%;
    }
  }
  ::v-deep.show-ambient-temp {
    label {
      margin-bottom: 0 !important;
    }
  }
}
::v-deep .export-div {
  top: 25px;
  right: 2rem;
}
::v-deep .width-29 {
  width: 29%;
  display: inline-block;
}
.close-btn {
  position: absolute;
  top: -0.7rem;
  right: 0;
  z-index: 9;
  padding: 1em;
}
.download-btn {
  position: absolute;
  right: 0;
  z-index: 9;
  padding: 1em;
}
.pointer {
  cursor: pointer;
}
.card-title {
  font-size: 0.75rem !important;
  font-family: Trade Gothic Regular !important;
  color: var(--v-primary-base);
  margin-bottom: 0;
}
</style>
